import React from "react";

export const StatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const colors: Record<string, string> = {
    success: "al-bg-green-100 al-text-green-800",
    error: "al-bg-red-100 al-text-red-800",
    empty: "al-bg-yellow-100 al-text-yellow-800",
    running: "al-bg-blue-100 al-text-blue-800",
  };
  const labels: Record<string, string> = {
    empty: "empty result",
  };
  return (
    <span
      className={`al-px-2 al-py-1 al-rounded al-text-xs al-font-medium al-whitespace-nowrap ${colors[status] || "al-bg-gray-100 al-text-gray-800"}`}
    >
      {labels[status] || status}
    </span>
  );
};
